import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { MeetingsService } from '../../../services/meetings.service';
import { AgentUtility} from '../../../util';
import { SSOUtility } from '../../../util/sso.utility';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AppSettings } from '../../../app.settings';
import { DadataService } from '../../../services/dadata.service';
import { Observable } from 'rxjs';
import { Meeting } from '../../../models/meeting';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css'],
  providers:[MeetingsService,DadataService]
})
export class CreateComponent implements OnInit {

  constructor(
    private meetingsService:MeetingsService,
    private router:Router,
    private dadataService:DadataService,
    private _location: Location
  ) { }

  ngOnInit() {
    this.initStartDate();
    this.initEndDate();
  }

  suggestions:any = {
    surname:[],
    name:[],
    patronymic:[]
  }

  datepickerOpts: any = {
	templates:{
	  leftArrow:"<",
	  rightArrow:">"
	},
	autoclose: true,
	todayHighlight: true,
	assumeNearbyYear: true,
	format: 'dd.mm.yyyy',
	placeholder: "Дата встречи",
	icon: 'client-full__calendar-new',
	language: 'ru'
  };

  errorMessage:string;
  phone:string;

  meeting:Meeting = new Meeting();
  

  meetingDate:Date = null;

  createMeeting(form:NgForm){
    if(!form.valid){
	let formValue = form.value;
	this.errorMessage = null;
	if(formValue.LastName === undefined || formValue.LastName == '') {
	  this.errorMessage = 'Сохранение невозможно. Заполните фамилию';
	}
	else if (formValue.FirstName === undefined || formValue.FirstName == '') {
	  this.errorMessage = 'Сохранение невозможно. Заполните имя';
	}
	else if (formValue.Date == null || formValue.Date == '') {
	  this.errorMessage = 'Сохранение невозможно. Введите дату встречи';
	}
	else if (formValue.Phone === "+7 (" || formValue.Phone == '') { 
	  this.errorMessage = 'Сохранение невозможно. Заполните номер телефона';
	}
	else if (formValue.isFirst == '' || formValue.isFirst == '') { 
	  this.errorMessage = 'Сохранение невозможно. Заполните встречу';
	}
	else if (formValue.Result == 'Продажа' && (formValue.PolicyNum == null || formValue.PolicyNum == '')) { 
	  this.errorMessage = 'Сохранение невозможно. Заполните номер договора';
	}
	else if (formValue.NextDate != undefined && (formValue.NextDate == null || formValue.NextDate == '01-01-1970')) { 
	  this.errorMessage = 'Сохранение невозможно. Дату повторной встречи';
	}
	else if (formValue.Result == 'Отказ' && formValue.Comment != undefined && (formValue.Comment == null || formValue.Comment == '')) { 
	  this.errorMessage = 'Сохранение невозможно. Укажите комментарий';
	}
	//this.errorMessage = 'Сохранение невозможно. Заполните обязательные поля';
	return;
    }
	
    if(!this.checkAgent)
	return;
    form.value["Phone"] = this.phone;

    let meetingForm = new Meeting();

    meetingForm = form.value;
	this.checkMeetingDate(form.value.Date);
   // let date = form.value.Date.toString(); //.toISOString();
   //let date = new Date(form.value.Date);
    
    form.value["Date"] = form.value.Date.toLocaleDateString();
    if(form.value.NextDate != undefined){
	    form.value["NextDate"] = form.value.NextDate.toLocaleDateString();
    }
    

    
    try{
	  this.meetingsService.createMeeting(meetingForm)
	  .subscribe(data => {
	    if(data.status == "OK")
		this.router.navigate(["/"])
	    else{
		this.setErrorMessage(data.data);
	    }
	  },
	  error => {
	    this.setErrorMessage(error);
	  })   
    }
    catch(error){
	this.setErrorMessage(error);
    }
  }

  checkMeetingDate(date) {
	let dateCheck = new Date(date);
    let startDate = new Date();
    startDate.setHours(0,0,0,0)
    let endDate = new Date();
    endDate.setHours(0,0,0,0)
    endDate.setMonth(endDate.getMonth() + 3);
    let errordate = dateCheck.getFullYear();
    if(errordate == 1970){
	this.errorMessage = "Сохранение невозможно. Заполните дату повторной встречи";
    }

    if(dateCheck < startDate || dateCheck > endDate)
	this.errorMessage = "Дата встречи должна быть в ближайшие 3 месяца";
  }

  isValid(form,name):boolean{
    return form.controls[name]? !form.controls[name].invalid : true;
  }

  getSuggestions(query:string,type:string){
    if(!query){
	this.clearSuggestions(type);
	return;
    }//"patronymic":
    if(type === 'patronymic'){
	query = 'patronymic: ' + query;
    }
    this.dadataService.getFioSuggestions(query).subscribe(data => {
	if(type === 'patronymic'){
	  this.suggestions[type] = data.suggestions.filter(s => s.data[type]).map(s => s.data.patronymic);
	}
	else{
	  this.suggestions[type] = data.suggestions.filter(s => s.data[type]).map(s => s.value);
	}
	
    })
  }

  getPhone(phone:string):string{
    if(!phone)
	return "+7 (";
    if(phone == "")
	return "+7 (";
    let type:string = phone.length < 3? "SHORT" : phone.length == 3? "MIDDLE" : "LONG";
    let result:string;
    switch(type){
	case "SHORT":
	  result = `+7 (${phone.slice(0,phone.length)}`;
	  break;
	case "MIDDLE":
	  result = `+7 (${phone.slice(0,3)})`;
	  break;
	case "LONG":
	  let middleCode = phone.slice(3,6);
	  let endCode = phone.length >= 6? phone.slice(6) : "";
	  result = endCode == "" ? `+7 (${phone.slice(0,3)}) ${middleCode}` : `+7 (${phone.slice(0,3)}) ${middleCode} ${endCode}`;
	  break;
    }
    return result;
  }

  setPhone(phone:string){
    this.phone = !phone? phone : phone.replace("+7","").replace("(","").replace(")","").replace(/\s/g,"");
    this.phone = this.phone.length > 10 ? this.phone.slice(0,10) : this.phone;
  }

  surname() {
    return Observable.of(this.suggestions.surname);
  }
  name() {
    return Observable.of(this.suggestions.name);
  }
  patronymic() {
    return Observable.of(this.suggestions.patronymic);
  }

  clearSuggestions(type:string){
    this.suggestions[type] = []
  }

  styleDatePickers(){
    let datepickers = document.getElementsByClassName("datepicker")
    for(let i = 0; i<datepickers.length; i++){
	datepickers[i].classList.add("datepicker-new")
    }
  }


  initStartDate(){
    let now = new Date();
    now.setHours(0,0,0,0);
    this.datepickerOpts.startDate = now
  }

  initEndDate(){
    let now = new Date();
    now.setHours(0,0,0,0);
    let currentMonth = now.getMonth();
    let maxDate = new Date(now.setMonth(currentMonth + 3));
    this.datepickerOpts.endDate = maxDate;
  }

  checkDate(date:Date){
    if(!date)
	return;
    if(date < this.datepickerOpts.startDate || date > this.datepickerOpts.endDate)
	this.errorMessage = "Дата встречи должна быть в ближайшие 3 месяца";
  }

  checkAgent():boolean{
    if(AgentUtility.IsOther()){
	this.errorMessage = "Нельзя назначить встречу за подчинённого";
	return false;
    }
    return true;
  }

  setErrorMessage(error){
    this.errorMessage = typeof(error) == "string" ? error : error.toString? error.toString() : "Неизвестная ошибка"
  }  

  goBack(){
    this._location.back();
  }

}
